import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import React, { PropsWithChildren, createContext, useContext, useEffect } from 'react';

const EditModeContext = createContext<boolean>(false);

export const useEditModeContext = (): boolean => {
  return useContext(EditModeContext);
};

type Props = {
  editMode: boolean;
};

export const EditModeProviderPlugin: React.FC<PropsWithChildren<Props>> = (props) => {
  const { children, editMode } = props;
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (editMode !== editor.isEditable()) {
      editor.setEditable(editMode);
    }
  }, [editor, editMode]);

  return (
    <EditModeContext.Provider value={editMode}>
      {children}
    </EditModeContext.Provider>
  );
};
